import styled from 'styled-components';

interface ICommentContainer {
  type: 'reclamation' | 'answer';
}

export const CommentContainer = styled.div<ICommentContainer>`
  display: flex;
  flex-direction: column;
  align-items: ${({ type }) => type === 'reclamation' ? 'flex-start' : 'flex-end'};
  width: 100%;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const MessageBubble = styled.div<ICommentContainer>`
  display: flex;
  flex-direction: column;
  max-width: 85%;
  background: ${({ theme, type }) =>
    type === 'reclamation'
      ? theme.colors.lighterBackground
      : theme.colors.primary.lighter};
  padding: 12px 16px;
  border-radius: ${({ type }) =>
    type === 'reclamation'
      ? '16px 16px 16px 4px'
      : '16px 16px 4px 16px'};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border-left: ${({ theme, type }) =>
    type === 'reclamation'
      ? `3px solid ${theme.colors.danger.main}`
      : 'none'};
  border-right: ${({ theme, type }) =>
    type === 'answer'
      ? `3px solid ${theme.colors.primary.main}`
      : 'none'};
`;

export const ConversationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px dashed ${({ theme }) => theme.colors.gray[75]};
  margin-bottom: 12px;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`;
